<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>
<div class="container">
    <h1 class="title-default">Implantação</h1>
    <p class="welcome-message">Bem vindo ao módulo <span class="display-name">Implantação</span>! Aqui tem todos as opções de configuração do módulo de implantação.</p>
    <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
</div>
